import React from "react";
import { StarFilled, StarOutlined } from "@ant-design/icons";

/**
 * @param {boolean} visible
 * @param {"filled"|"outline"} [variant="filled"] 區塊首頁＝實心；分組預設＝空心
 */
export default function ModuleDefaultHomeIndicator({
  visible,
  variant = "filled",
}) {
  if (!visible) return null;

  const isOutline = variant === "outline";
  const Icon = isOutline ? StarOutlined : StarFilled;
  const label = isOutline ? "分組預設頁" : "區塊預設首頁";

  return (
    <Icon
      className={`module-default-home__menu-indicator${
        isOutline ? " module-default-home__menu-indicator--outline" : ""
      }`}
      aria-label={label}
      title={label}
    />
  );
}
